import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
function animatePopover(state) {
    switch (state) {
        case 'hidden':
            return css `
        display: none;
        transform: translate(0, 0.25rem);
        opacity: 0;
      `;
        case 'entering':
        case 'leaving':
            return css `
        transform: translate(0, 0.25rem);
        opacity: 0;
        display: flex;
      `;
        default:
            return css `
        transform: translate(0, 0);
        opacity: 1;
        display: flex;
      `;
    }
}
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.gray.0')};
  box-shadow: ${(props) => themeGet(`dropShadow.${props.$shadow}`)};
  padding: ${(props) => (props.$padding === 0 ? 0 : themeGet(`spacing.${props.$padding}`))};

  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};

  ${(props) => animatePopover(props.$state)};

  transition:
    opacity ${themeGet('motion.duration.fast')} ${themeGet('motion.easing.standard')},
    transform ${themeGet('motion.duration.fast')} ${themeGet('motion.easing.standard')};
`;
